import React, { useState, useEffect } from "react";
import { useData } from "../backend/firebase";
import { useNavigate, useLocation } from "react-router-dom";
import BridgeBrawlLogo from "./BridgeBrawlLogo";

export default function SideBar() {
    const { userRole, user, logout, navigation } = useData();
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false); // Mobile Toggle State
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Listen for window resize to handle logic switching
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const items = (navigation || []).filter(item => item.visible !== false || user);

    const handleNav = (link) => {
        navigate(link);
        setIsOpen(false); // Close sidebar on mobile after click
    };

    // --- LOGO LOGIC UPDATED ---
    // If Mobile: Always small height (50px) to fit in header bar
    // If Desktop: Full width (180px) for the sidebar column
    const logoProps = isMobile 
        ? { height: 50, width: "auto" } 
        : { width: 180, height: "auto" };

    return (
        <div className={`Sidebar ${isOpen ? 'open' : ''}`}>
            <div className="SidebarHeader">
                <div onClick={() => handleNav('/')} style={{cursor:'pointer', display:'flex', alignItems:'center', filter: 'drop-shadow(0px 10px 20px rgba(0,0,0,0.5))', transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)'}}>
                    <BridgeBrawlLogo {...logoProps} />
                </div>
                
                {/* Hamburger Button */}
                <button className="MobileMenuToggle" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? "✕" : "☰"}
                </button>
            </div>
            
            <ul className="SidebarList">
                {items.map((val, key) => {
                    const isHidden = val.visible === false;
                    return (
                        <li
                            key={key}
                            className="row"
                            id={location.pathname === val.link ? "active" : ""}
                            onClick={() => handleNav(val.link)}
                            style={{ opacity: isHidden ? 0.5 : 1, justifyContent: 'space-between', paddingRight: 15 }}
                        >
                            <span>{val.title}</span>
                            {isHidden && <span style={{fontSize: 9, border: '1px solid #8F9EB5', padding: '1px 3px', borderRadius: 4}}>OFF</span>}
                        </li>
                    );
                })}

                {userRole && (userRole.role === 'captain' || userRole.role === 'admin') && (
                    <li 
                        className="row" 
                        id={location.pathname === "/captain" ? "active" : ""}
                        onClick={() => navigate('/captain')}
                    >
                        <div style={{ flex: 1 }}>Captain Portal</div>
                    </li>
                )}

                {userRole && (userRole.role === 'admin') && (
                    <li className="row" id={location.pathname === '/admin' ? "active" : ""} onClick={() => handleNav('/admin')}>
                        Admin Dashboard
                    </li>
                )}

                <div style={{ marginTop: "auto", padding: 20, width: "100%" }}>
                    {user ? (
                        <div onClick={logout} className="row" style={{ justifyContent: 'center', color: '#FF5C5C' }}>Logout</div>
                    ) : (
                        <div onClick={() => handleNav('/login')} className="row" style={{ justifyContent: 'center', fontSize: 12, opacity: 0.5 }}>Admin Login</div>
                    )}
                </div>
            </ul>
        </div>
    );
}